/**
 * Converts the casing of the first letter of the string to uppercase.
 * @param s The string to convert.
 * @returns A new string with the first letter in uppercase.
 * @example
 * ucFirst('hello world'); // 'Hello world'
 * ucFirst('Hello world'); // 'Hello world'
 * ucFirst('HELLO WORLD'); // 'HELLO WORLD'
 * ucFirst(''); // ''
 */
export const ucFirst = (s: string) => `${s.charAt(0).toLocaleUpperCase()}${s.substring(1)}`;

/**
 * Converts the string to title case, i.e. the first letter of each word is capitalized.
 * @param s The string to convert.
 * @returns A new string in title case.
 * @example
 * titleCase('hello world'); // 'Hello World'
 * titleCase('hello-world, hey!'); // 'Hello-world, Hey!'
 * titleCase('helloWORLD'); // 'HelloWORLD'
 */
export const titleCase = (s: string) => s.replace(/(^|\s)[\w]/g, (a) => a.toLocaleUpperCase());
